"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface SuccessStory {
  title: string;
  description: string;
  image: string;
  link: string;
}
const successStories: SuccessStory[] = [{
  title: "EVERYTHING FEELS THE SAME",
  description: "Producer / Song Writer / Mix Engineer. A deep dive into psychedelic indie textures, capturing the raw energy with a focus on analogue warmth.",
  image: "https://possible-crane.10web.cloud/wp-content/uploads/2026/04/8808CBAD-16F5-4C54-A5CC-AE41BE9A5E10-scaled.jpeg?v=eqgmjhennmu",
  link: "https://iammileshen.com/the-sound/"
}, {
  title: "JAZZ",
  description: "Recording / Mix Engineer. Capturing the vibrant energy of live jazz recordings with a focus on natural room acoustics and authentic instrumental performance.",
  image: "https://possible-crane.10web.cloud/wp-content/uploads/2026/04/IMG_20230130_161703-scaled.jpg?v=47fusc6twxa",
  link: "https://iammileshen.com/the-sound/"
}, {
  title: "NURSERY GRIMES\n",
  description: "Producer / Mix Engineer. A brutalist industrial goth production featuring heavy guitars and percussion, distorted synth beds, and high-contrast sonic textures.",
  image: "https://possible-crane.10web.cloud/wp-content/uploads/2026/04/Snapchat-1570340203.jpg?v=7bi4gnqaf1",
  link: "https://iammileshen.com/the-sound/"
}];
export default function SuccessStoriesInMotion() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224091" id="selected-works" className="bg-background text-foreground py-20 md:py-24">
      <div ref={ref} className={`mx-auto max-w-7xl px-4 sm:px-6 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="mb-12 text-center">
          <h2 className="font-default text-foreground mb-4 text-4xl font-bold md:text-5xl tracking-tighter uppercase">
            Selected Works
          </h2>
          <p className="text-muted-foreground mx-auto max-w-2xl text-lg font-default">
            A curated selection of creative collaborations across production, mixing, and experimental sound design.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {successStories.map((story, i) => <Card key={i} data-index={i} className="bg-card/40 border-none flex h-full flex-col overflow-hidden transition-all duration-300 hover:bg-card/60">
              <div className="relative h-80 md:h-64 w-full shrink-0 overflow-hidden">
                <img src={story.image} alt={story.title} className="h-full w-full object-cover object-center grayscale transition-all duration-500 hover:scale-105 hover:grayscale-0" />
              </div>
              <CardContent className="flex flex-1 flex-col p-8">
                <h3 className="font-default text-foreground mb-3 text-2xl font-semibold tracking-tight uppercase">
                  {story.title}
                </h3>
                <p className="text-muted-foreground mb-6 flex-1 text-sm leading-relaxed font-sans">
                  {story.description}
                </p>
                <div className="mt-auto">
                  <Link to={story.link} className="text-primary group inline-flex items-center font-mono text-xs font-bold tracking-widest transition-colors hover:text-primary/80">
                    VIEW PROJECT
                    <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
                  </Link>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}